import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Layout from './components/Layout';
import Musicians from './pages/Musicians';
import Songs from './pages/Songs';
import Schedules from './pages/Schedules';
import Instruments from './pages/Instruments';
import ChurchSettings from './pages/ChurchSettings';
import ServiceGenerator from './pages/ServiceGenerator';
import Unavailability from './pages/Unavailability';
import Profile from './pages/Profile';
import VersionChecker from './components/VersionChecker';

// Componente para proteger rotas
function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <VersionChecker /> {/* <--- ADICIONE AQUI */}
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* Rotas Protegidas com Layout */}
          <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route path="/" element={<Dashboard />} />
            
            {/* Futuras rotas (Placeholder para não dar erro 404 se clicar agora) */}
            <Route path="/escalas" element={<Schedules />} />
            <Route path="/musicas" element={<Songs />} />         
            <Route path="/musicos" element={<Musicians />} />
            <Route path="/instrumentos" element={<Instruments />} />            
            <Route path="/igreja" element={<ChurchSettings />} />
            <Route path="/gerador" element={<ServiceGenerator />} />
            <Route path="/indisponibilidade" element={<Unavailability />} />
            <Route path="/perfil" element={<Profile />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;